import SubscriptionConstants from 'client/Payments/pricingMatrix/SubscriptionConstants';

const { AttributeDetails } = SubscriptionConstants;

export default {
  methods: {
    getAttributeDescription(attribute) {
      const { description, name } = AttributeDetails[attribute];
      if (!description) return null;
      return `${name}: ${description}`;
    },

    getAttributeDisplayName(attribute) {
      const attributeDisplayNameConfig = AttributeDetails[attribute];
      const { name } = attributeDisplayNameConfig;
      return name;
    },

    getAttributeIcon(attribute) {
      const { icon } = AttributeDetails[attribute];
      return icon || 'jcLogo';
    },

    getCloudDirectoryName(attribute) {
      const { cloudDirectoryName } = AttributeDetails[attribute];
      return cloudDirectoryName;
    },

    getStandardSupportName(attribute) {
      const { standardSupportName } = AttributeDetails[attribute];
      return standardSupportName;
    },

    getCloudDirectoryDescription(attribute) {
      const { cloudDirectoryDescription } = AttributeDetails[attribute];
      return cloudDirectoryDescription;
    },

    getStandardSupportDescription(attribute) {
      const { standardSupportDescription } = AttributeDetails[attribute];
      return standardSupportDescription;
    },
  },
};
